<div class="content-container margin-bottom">
    <div class="feedback-container">
        <div>
            <p>We hope you're finding the new time-keeping system useful. As with any new tool, there's always room for improvement, and your feedback is invaluable. For a limited time, this feedback tab will remain available for you to report any bugs or share suggestions for enhancements.</p>
            <p>Even after this tab is removed, we will continue to welcome your input through the 
                <a 
                    title="Email ITS Help Desk" 
                    href="mailto:its-helpdesk@uiowa.edu?subject=Regarding the ITS Time Tracker application"
                    class="inline-link">
                    ITS Help Desk
                </a>.
            </p>
            <p>Thank you for your continued support.</p>
        </div>
        <div class="form-container margin-lg-top">
            <mat-form-field class="feedback-type">
                <mat-label>Feedback type</mat-label>
                <mat-select [(ngModel)]="feedbackType">
                    <mat-option value="bug">Bug Report</mat-option>
                    <mat-option value="feature">Feature Request</mat-option>
                    <mat-option value="other">Other</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="feedback" appearance="outline">
                <mat-label>Add Feedback</mat-label>
                <textarea matInput [(ngModel)]="feedback" [placeholder]="placeholder"></textarea>
            </mat-form-field>

            <!-- <button mat-flat-button class="submit-btn" (click)="addFeedback()">Submit Feedback</button> -->
            <button 
                mat-flat-button 
                class="submit-btn"
                (click)="addFeedback()">
                <mat-icon>add</mat-icon>
                Submit Feedback
            </button>
        </div>
    </div>
</div>